/* ALFAVITA Hair Assessment Quiz engine.
 * Fully client-side: no backend, no API keys, no photos collected at any point.
 * The visitor self-assesses their stage on the Norwood chart. Answers persist in
 * sessionStorage (never localStorage) so a refresh mid-quiz doesn't lose them.
 * Timeline numbers come exclusively from assets/norwood-timeline.json.
 */
(function () {
  'use strict';

  var root = document.getElementById('hair-quiz');
  if (!root) return;

  var cfg = JSON.parse(root.querySelector('[data-hq-config]').textContent);
  var SS_KEY = 'alfavita_hair_quiz_v1';

  /* ---------- state ---------- */
  var state = { answers: {}, stack: [] };
  try {
    var saved = sessionStorage.getItem(SS_KEY);
    if (saved) state = JSON.parse(saved);
    if (!state.answers) state.answers = {};
    if (!state.stack) state.stack = [];
  } catch (e) { /* private mode etc. — quiz still works, just no refresh persistence */ }

  function persist() {
    try { sessionStorage.setItem(SS_KEY, JSON.stringify(state)); } catch (e) {}
  }

  /* ---------- DOM helpers ---------- */
  function $(sel, scope) { return (scope || root).querySelector(sel); }
  function $all(sel, scope) { return Array.prototype.slice.call((scope || root).querySelectorAll(sel)); }
  function stepEl(id) { return $('[data-hq-step="' + id + '"]'); }
  function fill(tpl, map) {
    var out = tpl;
    Object.keys(map).forEach(function (k) { out = out.split(k).join(map[k]); });
    return out;
  }
  function stageLabel(stage) {
    var btn = $('[data-hq-stage="' + stage + '"]');
    return btn ? btn.getAttribute('data-label') : stage;
  }

  /* ---------- timeline lookup ---------- */
  var timeline = null;
  var timelinePromise = null;
  function loadTimeline() {
    if (timelinePromise) return timelinePromise;
    timelinePromise = fetch(cfg.timelineUrl).then(function (r) {
      if (!r.ok) throw new Error('timeline http ' + r.status);
      return r.json();
    }).then(function (j) { timeline = j; return j; })
      .catch(function () { timelinePromise = null; timeline = null; return null; });
    return timelinePromise;
  }
  function minoxTableKey() {
    // Only current established use (3+ months) counts as "yes"; recent starters
    // and "stopped" map to the non-minoxidil table.
    return state.answers.minoxidil === 'yes_established' ? 'yes' : 'no';
  }
  function currentMinoxUser() {
    return state.answers.minoxidil === 'yes_established' || state.answers.minoxidil === 'yes_recent';
  }
  function lookupEntry() {
    if (!timeline || !timeline.entries || !state.answers.stage) return null;
    return timeline.entries[state.answers.stage + '|' + state.answers.duration + '|' + minoxTableKey()] || null;
  }

  /* ---------- slide transition ----------
     The same motion as keep-my-hair-quiz, taken from the Keeps quiz shell:
     leaving a step fades out over 300ms and the swap happens at 300ms; the
     incoming step slides 40px from the right and fades in over 500ms after a
     50ms delay. Falls back to an instant swap if the wrapper is missing. */
  var slides = $('[data-hq-slides]');
  var LEAVE_MS = 300, ENTER_MS = 500, ENTER_DELAY = 50;
  var animating = false;

  function animateIn() {
    if (!slides) return;
    slides.classList.remove('is-leaving', 'is-entered');
    slides.classList.add('is-entering');
    void slides.offsetWidth;              /* force reflow before the transition */
    slides.classList.remove('is-entering');
    slides.classList.add('is-entered');
    window.setTimeout(function () { slides.style.willChange = 'auto'; },
      ENTER_MS + ENTER_DELAY + 50);
  }

  function transition(fn) {
    if (!slides) { fn(); return; }
    if (animating) return;
    animating = true;
    slides.classList.remove('is-entered', 'is-entering');
    slides.classList.add('is-leaving');
    window.setTimeout(function () { animating = false; fn(); }, LEAVE_MS);
  }

  /* ---------- flow ---------- */
  function flowSteps() {
    var base = ['goal', 'duration', 'minoxidil', 'chart', 'result'];
    var entry = state.answers._entry || null;
    if (entry && entry.route !== 'standard') return base.concat(['lead']);
    return base.concat(['timeline', 'how', 'q1', 'q2', 'q3', 'lead']);
  }

  function progressIndex(stepId) {
    var flow = flowSteps();
    var i = flow.indexOf(stepId);
    return i === -1 ? flow.length : i;
  }

  function show(stepId, opts) {
    opts = opts || {};
    $all('.hq-step').forEach(function (el) { el.hidden = el.getAttribute('data-hq-step') !== stepId; });
    var flow = flowSteps();
    var idx = progressIndex(stepId);
    var bar = $('[data-hq-progress]');
    if (bar) bar.style.transform = 'scaleX(' + ((idx + 1) / flow.length).toFixed(4) + ')';
    var lbl = $('[data-hq-progress-label]');
    if (lbl) {
      lbl.textContent = stepId === 'thanks' ? '' :
        fill(lbl.getAttribute('data-template'), { __STEP__: String(idx + 1), __TOTAL__: String(flow.length) });
    }
    var back = $('[data-hq-back]');
    if (back) back.hidden = state.stack.length === 0 || stepId === 'thanks';
    state.current = stepId;
    if (!opts.noPush) persist();
    window.scrollTo(0, 0);

    animateIn();

    if (stepId === 'result') enterResult();
    if (stepId === 'timeline') enterTimeline();
    if (stepId === 'how') enterHow();
    if (stepId === 'lead') enterLead();
  }

  function goTo(stepId, opts) {
    transition(function () {
      if (state.current && state.current !== stepId) state.stack.push(state.current);
      show(stepId, opts);
    });
  }

  function goBack() {
    if (!state.stack.length) return;
    transition(function () {
      var prev = state.stack.pop();
      if (!prev) return;
      show(prev, { noPush: false });
    });
  }

  /* ---------- step 4: chart (self-assessment) ---------- */
  function setStage(stage) {
    state.answers.stage = stage;
    persist();
    loadTimeline().then(function () {
      state.answers._entry = lookupEntry();
      persist();
      goTo('result');
    });
  }

  /* ---------- step 5: result ---------- */
  function enterResult() {
    var entry = state.answers._entry || lookupEntry();
    state.answers._entry = entry;
    var durLabel = (cfg.durLabels && cfg.durLabels[state.answers.duration]) || '';
    var goalLabel = (cfg.goalLabels && cfg.goalLabels[state.answers.goal]) || '';
    var sLabel = stageLabel(state.answers.stage);
    $('[data-hq-stage-label]').textContent = sLabel;

    var variant = entry ? entry.copy_variant : 'thickening_only';
    $all('[data-hq-variant]').forEach(function (p) {
      var active = p.getAttribute('data-hq-variant') === variant;
      p.hidden = !active;
      if (active) {
        if (!p.getAttribute('data-raw')) p.setAttribute('data-raw', p.textContent);
        p.textContent = fill(p.getAttribute('data-raw'), { __DUR__: durLabel, __GOAL__: goalLabel, __STAGE__: sLabel });
      }
    });

    var conflict = $('[data-hq-conflict]');
    var tier = entry ? entry.tier : null;
    var showConflict = state.answers.goal === 'regrow' && (tier === 'C' || tier === 'D') && variant !== 'nw67';
    conflict.hidden = !showConflict;
    if (showConflict) {
      if (!conflict.getAttribute('data-raw')) conflict.setAttribute('data-raw', conflict.textContent);
      conflict.textContent = fill(conflict.getAttribute('data-raw'), { __STAGE__: sLabel, __DUR__: durLabel });
    }
  }

  /* ---------- step 6: timeline ---------- */
  function enterTimeline() {
    var entry = state.answers._entry;
    if (!entry || !entry.first_visible_months) { goTo('how'); return; }
    var fv = $('[data-hq-fv-range]');
    var mm = $('[data-hq-mm-range]');
    fv.textContent = fill(fv.getAttribute('data-template'), { __LO__: String(entry.first_visible_months[0]), __HI__: String(entry.first_visible_months[1]) });
    mm.textContent = fill(mm.getAttribute('data-template'), { __LO__: String(entry.meaningful_months[0]), __HI__: String(entry.meaningful_months[1]) });
  }

  /* ---------- step 7: how ---------- */
  function enterHow() {
    // safety disclosure: renders for every current-minoxidil user
    $('[data-hq-minox-warning]').hidden = !currentMinoxUser();
  }

  /* ---------- step 11: lead ---------- */
  function enterLead() {
    var entry = state.answers._entry || {};
    var isExit = entry.route && entry.route !== 'standard';
    $('[data-hq-lead-standard]').hidden = isExit;
    $('[data-hq-lead-exit]').hidden = !isExit;
    var submit = $('[data-hq-submit]');
    submit.textContent = submit.getAttribute(isExit ? 'data-exit' : 'data-standard');

    // tier + eligibility only — the estimated Norwood stage is NEVER tagged or stored
    var minoxTag = { yes_established: 'yes', yes_recent: 'recent', stopped: 'stopped', never: 'never' }[state.answers.minoxidil] || 'na';
    var tags = [
      'hair-quiz',
      'hq-tier-' + (entry.tier || 'na'),
      'hq-dur-' + (state.answers.duration || 'na'),
      'hq-minox-' + minoxTag,
      'hq-commit-' + (state.answers.q1 || 'na'),
      'hq-route-' + (entry.route || 'standard')
    ];
    $('[data-hq-tags]').value = tags.join(', ');

    var returnTo;
    if (isExit) {
      returnTo = cfg.returnTo + '?hq_done=1';
    } else {
      var sep = cfg.pdpUrl.indexOf('?') === -1 ? '?' : '&';
      returnTo = cfg.pdpUrl + sep +
        'utm_source=hair-quiz&utm_medium=quiz&utm_campaign=hair-assessment&utm_content=tier-' + (entry.tier || 'na');
    }
    $('[data-hq-return-to]').value = returnTo;
  }

  /* ---------- wiring ---------- */
  $all('[data-hq-answer]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var q = btn.getAttribute('data-hq-answer');
      state.answers[q] = btn.getAttribute('data-value');
      persist();
      $all('[data-hq-answer="' + q + '"]').forEach(function (b) {
        b.classList.toggle('is-selected', b === btn);
      });
      var flow = flowSteps();
      var next = flow[flow.indexOf(q) + 1];
      if (q === 'q3' || (q === 'q1' && flow.indexOf('q2') === -1)) next = 'lead';
      goTo(next || 'lead');
    });
  });

  $('[data-hq-back]').addEventListener('click', goBack);

  $all('.hq-stage').forEach(function (btn) {
    btn.addEventListener('click', function () {
      $all('.hq-stage').forEach(function (b) { b.classList.toggle('is-selected', b === btn); });
      setStage(btn.getAttribute('data-hq-stage'));
    });
  });
  $all('[data-hq-next]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var flow = flowSteps();
      var cur = state.current;
      goTo(flow[flow.indexOf(cur) + 1] || 'lead');
    });
  });

  var form = $('.hq-form');
  if (form) {
    form.addEventListener('submit', function () {
      // best-effort parallel identify if Omnisend is already installed — no new scripts
      try {
        if (window.omnisend && typeof window.omnisend.push === 'function') {
          var email = form.querySelector('[name="contact[email]"]').value;
          var first = form.querySelector('[name="contact[first_name]"]').value;
          window.omnisend.push(['identifyContact', { email: email, firstName: first }]);
        }
      } catch (e) {}
    });
  }

  /* ---------- boot ---------- */
  var params = new URLSearchParams(location.search);
  if (params.get('hq_done') === '1') {
    try { sessionStorage.removeItem(SS_KEY); } catch (e) {}
    state = { answers: {}, stack: [] };
    show('thanks', { noPush: true });
  } else if (form && form.querySelector('.hq-error')) {
    // Shopify re-rendered the page with form errors — go straight back to the lead step
    state.stack = state.stack || [];
    show('lead', { noPush: true });
  } else if (state.current && stepEl(state.current)) {
    show(state.current, { noPush: true });
  } else {
    show('goal', { noPush: true });
  }
})();
